import MuiGlobalStyles, {
  type GlobalStylesProps,
} from "@mui/material/GlobalStyles";

export type { GlobalStylesProps };

export function GlobalStyles(props: GlobalStylesProps) {
  return <MuiGlobalStyles {...props} />;
}
